import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ObjectUsages } from '../../../models/object-mapping.model';

/** Verwender eines Objekts: Testfaelle, Testmodule und unverknuepfte Schritte mit ihren Zeilen (NEX-1278). */
@Component({
  selector: 'app-object-usage-list',
  imports: [NgTemplateOutlet, RouterLink, TranslatePipe],
  templateUrl: './object-usage-list.component.html',
  styleUrl: './object-usage-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectUsageListComponent {
  readonly usages = input.required<ObjectUsages>();
  readonly projectId = input.required<string>();

  readonly empty = computed(() => {
    const usages = this.usages();
    return usages.testCases.length === 0 && usages.modules.length === 0 && usages.unlinkedSteps.length === 0;
  });

  readonly duplicatesHint = computed(() => {
    const duplicates = this.usages().duplicates;
    if (!duplicates) {
      return null;
    }
    const kind = duplicates.assigned ? 'assigned' : duplicates.resolvedMapping ? 'notAssigned' : 'unresolved';
    return {
      key: `objectMappings.usages.duplicates.${kind}`,
      params: { others: duplicates.otherMappings.join(', '), resolved: duplicates.resolvedMapping },
    };
  });
}
